import MutationTypes from '../../MutationTypes';

export default {
    [MutationTypes.SET_NETWORK_STATE]: (state, payload) => {
        state.newtwork = payload;
    },
    [MutationTypes.SET_SCREEN_ORIENTATION]: (state, payload) => {
        state.screen = payload;
    }
};
